import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import TextTruncate from 'react-text-truncate';
import Like from 'appSrc/components/Like';
import { PrimaryButton, ExternalLink } from 'appSrc/components/UI';
import { fixCurrency } from 'appSrc/utils/random';
import { parseYouTubeUrl, convertYouTubeIdToImg } from 'appSrc/utils/video';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import { GoogleTagManager } from 'appSrc/components/Analytics/GoogleTagManager';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/NewPlayIcon';
import { ReviewSubcard } from './Subcard';
import style from './styles/style.module.css';

class ReviewFocusedProductCard extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = { mounted: false };
    }
    componentDidMount() {
        this.setState( { mounted: true } );
    }
    trackPurchase = () => {
        var product = this.props.product;
        var retailer = /^(?:https?:\/\/)?([^\/\?\:]+)/.exec( product.originalUrl );
        var likes = !product.likes ? 0 : parseInt( product.likes );
        GoogleTagManager.firePurchaseClick( product.desireid );
        Mixpanel.track( 'productPurchased', {
            id: product.desireid,
            name: product.title,
            price: product.price,
            retailer: retailer[1] || retailer[0],
            date_created: product.dateCreated,
            like_count: likes,
            source_url: product.url,
            author: product.userid,
            list: product.listid,
        } );
    }
    render() {
        const { product } = this.props;
        const retailer = product.originalUrl.replace( /^https?:\/\/(?:[^\.]*\.)?([^\.]*\.[^\/]*).*$/, '$1' );
        const productUrl = '/app/products/' + product.desireid;

        var movieMetaData = {};

        // display the first available review
        let firstReview = null;
        let video, videoId, videoImage;
        if ( product.reviews && product.reviews.length > 0 ) {
            firstReview = product.reviews[ 0 ];

            movieMetaData = {
                attached_to: 'review_video',
                attached_id: firstReview.id,
                video_author_id: firstReview.userid,
            };
            video = firstReview.video_url;
            if( video ) {
                videoId = parseYouTubeUrl( video );
                videoImage = convertYouTubeIdToImg( videoId );
            }
        }
        if( firstReview === null || video === undefined ) {
            return null;
        }

        return (
            <div className={ `${ style.explodingZone } ${ this.props.className }` } id={ this.props.id }>
                <div className={ style.explodingProductCard }>
                    <div className={ style.cardTop }>
                        <div className={ style.imageCard }>
                            <ExternalLink className={ style.retailer }
                            href={ product.url || product.originalUrl }
                            onClick={ this.trackPurchase } >
                                { retailer }
                            </ExternalLink>
                            <div className={ style.floatWrapper }>
                                <Link to={ productUrl } className={ style.blockLink }>
                                    <AspectRatio ratio='1/1'>
                                        <div className={ style.imageWrapper }>
                                            <img src={ videoImage } />
                                        </div>
                                    </AspectRatio>
                                </Link>
                                <TheaterPlayIcon className={ style.playButton } youtubeId={ parseYouTubeUrl( firstReview.video_url ) }
                                metaData={ movieMetaData } />
                            </div>
                            { this.props.self.userid !== product.userid &&
                                <div className={ style.likeWrapper }>
                                    <Like
                                    size={ 20 }
                                    type="product"
                                    item={ product }
                                    label='Favorite'
                                    iconStyle={ { color: 'black' } }
                                    onUpdate={ this.props.onLike }/>
                                </div>
                            }
                        </div>

                        <div className={ style.basics }>
                            <Link to={ productUrl } >
                                <div className={ style.price }>${ fixCurrency( product.price ) }</div>
                                <TextTruncate
                                line={ 3 }
                                text={ product.title }
                                title={ product.title }
                                containerClassName={ style.detail }/>
                            </Link>
                        </div>
                    </div>

                    <div className={ style.cardBody }>
                        <Link to={ productUrl } className={ style.blockLink }>
                            <TextTruncate
                            line={ 5 }
                            text={ firstReview.review_text }
                            containerClassName={ style.description }/>
                        </Link>
                        <ExternalLink className={ style.purchaseLink } to={ product.url }>
                            <PrimaryButton
                            label='Purchase'
                            onClick={ this.trackPurchase }
                            fullWidth />
                        </ExternalLink>
                    </div>

                    <ReviewSubcard review={ firstReview } className={ style.subCard } />

                    <Link to={ '/app/products/' + product.desireid } className={ style.viewProductCard }>
                        Learn More
                    </Link>
                </div>
            </div>
        );
    }
}
ReviewFocusedProductCard.defaultProps = {
    product: {},
    onLike: response => response,
    id: null,
    className: '',
};
ReviewFocusedProductCard.propTypes = {
    product: PropTypes.object.isRequired,
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        screenSize: state.screenSize.width,
    };
};

export default connect( mapStateToProps )( ReviewFocusedProductCard );
